import Vue from 'vue'
import { SnackBarInput } from './types';
export default Vue.extend({
  data(){
    return {
      isShowSnackBar: false,
      responseMessage: '',
      snackbarType: '', //success | error | info
      snackBarColour: ''
    }//TODO intergrate timeout
  },
  methods: {
    showNotifier(input: SnackBarInput) {
      this.$data.responseMessage = input.message;
      if(input.colour) this.$data.snackBarColour = input.colour;
      if(input.snackbarType) this.$data.snackbarType = input.snackbarType;
      this.$data.isShowSnackBar = true;
    },
    resetSnackBar(){
      this.$data.isShowSnackBar = false;
    },
  }
})